/**
 * @file paddle 学术生态请求方法
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import request from 'superagent';
import baseRequest from '../baseApi';


// 获取学术生态
export interface IGetCommunityParam {
    requestUrl?: string;
}

export const getAcademicInfo = (params: IGetCommunityParam | string): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query(params)
            .query(window.location.search.slice(1))
    );